<template src="./template.html"></template>
<script>
import { mapState } from 'vuex'
import Vue from 'vue'

import iframeWidgetBaseMixin from 'mixins/iframeWidgetBase'
import store from 'src/store'
import * as mutationTypes from 'store/mutationTypes'
import IFRAME_MESSAGE_TYPES from 'shared/constants/iframeMessageTypes'
import domUtils from 'utils/domUtils'
import authHelper from 'api/auth/helper'
import ROUTE_NAMES from 'constants/routeNames'

export default {
  name: 'chat-app',
  mixins: [iframeWidgetBaseMixin],
  computed: {
    ...mapState({
      user: (state) => state.user.current,
      date: (state) => state.date.current,
      venue: (state) => state.venue.current,
      chatVisible: (state) => state.chatApp.visible,
      totalUnreadChatMessages: (state) => state.chat.totalUnreadMessages,
    }),
  },
  data() {
    return {
      fullScreenMode: false,
      loading: true,
      initialUserLoad: true,
      userLoaded: false,
      venueId: this.$route.query.venueId,
      errorLoading: false,
      chatOpen: false,
      disablePublish: false,
    }
  },
  methods: {
    toggleChat() {
      if (this.chatOpen) {
        this.disablePublish = true

        this.chatOpen = false

        setTimeout(() => {
          this.$store.dispatch('hideChatApp')

          this.disablePublish = false
        }, 300)
      } else {
        this.$store.dispatch('showChatApp')

        setTimeout(() => {
          this.chatOpen = true
        }, 150)
      }
    },
    onMutation(mutation) {
      if (mutation.type === mutationTypes.TOGGLE_CHAT_APP) {
        this.toggleChat()
      } else if (mutation.type === mutationTypes.LOGIN_SUCCESS) {
        this.publishIframeMessage(IFRAME_MESSAGE_TYPES.LOG_IN, {
          authToken: authHelper.getAuthToken(),
        })
      } else if (mutation.type === mutationTypes.LOGOUT_SUCCESS) {
        this.publishIframeMessage(IFRAME_MESSAGE_TYPES.LOG_OUT)
      } else if (mutation.type === mutationTypes.SET_CURRENT_USER) {
        this.userLoaded = true

        if (this.initialUserLoad) {
          this.initialUserLoad = false

          if (!this.user.firstName || !this.user.lastName || !this.user.email) {
            this.$router.push({
              name: ROUTE_NAMES.CHAT_APP_GUEST,
            })
          }
        }
      } else if (mutation.type === mutationTypes.SHOW_CHAT_APP) {
        this.publishIframeMessage(IFRAME_MESSAGE_TYPES.SHOW_CHAT_APP)
      } else if (mutation.type === mutationTypes.HIDE_CHAT_APP) {
        this.publishIframeMessage(IFRAME_MESSAGE_TYPES.HIDE_CHAT_APP)
      }
    },
    publishDimensions(options = {}) {
      if (this.disablePublish) {
        return
      }

      const el = this.chatOpen ? this.$refs.widgetContainer : this.$refs.chatLaunchButtonEl

      if (!el) {
        console.log('widget has no ref - resizing disabled') //eslint-disable-line
        return
      }

      let height
      let width

      try {
        //NOTE: all iframe widgets need to have a ref="widgetContainer" attribution set on the outermost container element
        height = domUtils.outerHeight(el, true)
        width = domUtils.outerWidth(this.chatOpen ? this.$refs.chatWrapperEl : el, true)
      } catch (err) {
        return
      }

      if (options.minHeight && options.minHeight > height) height = options.minHeight
      if (this.minHeight && this.minHeight > height) height = this.minHeight
      if (options.maxHeight && options.maxHeight < height) height = options.maxHeight

      this.publishIframeMessage(IFRAME_MESSAGE_TYPES.IFRAME_DIMENSIONS_UPDATED, {
        height,
        width,
      })
    },
    onWindowResized(data) {
      if (data.innerWidth < 501) {
        this.fullScreenMode = true
      } else {
        this.fullScreenMode = false
      }

      Vue.nextTick(() => {
        this.publishDimensions()
      })
    },
    onIframeMessage(message) {
      if (message.data.type === IFRAME_MESSAGE_TYPES.IFRAME_WINDOW_RESIZED) {
        this.onWindowResized(message.data.data)
      } else if (message.data.type === IFRAME_MESSAGE_TYPES.LOG_IN) {
        this.$store
          .dispatch('logoutFromIframe')
          .then(() =>
            this.$store.dispatch('loginFromIframe', {
              token: message.data.data.authToken,
            })
          )
          .then(() => this.$store.dispatch('getCurrentUser'))
          .then(() => {
            this.$router.push({
              name: ROUTE_NAMES.CHAT_APP_HOME,
            })
          })
      } else if (message.data.type === IFRAME_MESSAGE_TYPES.LOG_OUT) {
        this.$store.dispatch('logoutFromIframe')

        this.$router.push({
          name: ROUTE_NAMES.CHAT_APP_GUEST,
        })
      }
    },
  },
  created() {
    if (this.$route.query.fullScreenMode) {
      this.fullScreenMode = true
    }

    this.storeUnsubscribe = store.subscribe(this.onMutation)

    this.loading = true

    const promises = []

    if (this.venueId) {
      promises.push(this.$store.dispatch('getVenue', this.venueId))
    } else {
      this.errorLoading = true
    }

    Promise.all(promises)
      .then(() => {
        this.loading = false
      })
      .catch(() => {
        this.loading = false
      })
  },
  destroyed() {
    if (this.storeUnsubscribe) this.storeUnsubscribe()
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/Widgets/Chat/ChatApp/index.vue